import { Modifier } from "@dnd-kit/core";
import { getEventCoordinates } from "@dnd-kit/utilities";
import { FolderDto } from "@repo/api/folder";
import { PagedVideoItemDto } from "@repo/api/video";

export type VideosDragData =
  | { type: "folder"; folder: FolderDto }
  | { type: "video"; video: PagedVideoItemDto };

export type FolderDropData = {
  folderExternalId: string | null;
};

export function folderDropId(folderExternalId: string | null) {
  return `folder-drop:${folderExternalId ?? "root"}`;
}

/** Keeps the drag overlay horizontally centered just above the cursor. */
export const snapAboveCursor: Modifier = ({
  activatorEvent,
  draggingNodeRect,
  transform,
}) => {
  if (!draggingNodeRect || !activatorEvent) {
    return transform;
  }

  const activatorCoordinates = getEventCoordinates(activatorEvent);
  if (!activatorCoordinates) {
    return transform;
  }

  const offsetX = activatorCoordinates.x - draggingNodeRect.left;
  const offsetY = activatorCoordinates.y - draggingNodeRect.top;

  return {
    ...transform,
    x: transform.x + offsetX - draggingNodeRect.width / 2,
    y: transform.y + offsetY - draggingNodeRect.height - 12,
  };
};
